import React, { useState, useEffect } from "react";
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import styles from "./App.module.css";
import Jobs from "./pages/Jobs/Jobs";
import BackupSettings from "./pages/BackupSettings/BackupSettings";
import Dashboard from "./pages/Dashboard/Dashboard";
import Backup from "./pages/Backup/Backup";
import Insights from "./pages/Insights/Insights";
import IssueLog from "./pages/IssueLog/IssueLog";
import Restore from "./pages/Restore/Restore";
import Navbar from "./components/Navbar/Navbar";
import Lostroute from "./pages/LostRoute/Lostroute";
import FlagError from "./components/Shared/Error/FlagError";
import { UseToast } from "./components/context/ToastContext";
import Unauthenticated from "./components/unAuthenticated/Unauthenticated";
import Authenticating from "./components/Authenticating/Authenticating";
import { API } from "./utility/Api";
import AuditLog from "./pages/AuditLog/AuditLog";
import { camelToTitle, errorHandler } from "./helpers/helpers";
import JobDetails from "./pages/JobDetails/JobDetails";
import { useSearchParams } from "react-router-dom";
import PostInstallPage from "./pages/PostInstallPage/PostInstallPage";

const App = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();

  const whereAmI = camelToTitle(location.pathname.split("/")[1]);

  const { setMainMessage, mainMessage } = UseToast();
  const [isAuth, setIsAuth] = useState("isAuthenticating");
  const logAppUse = async (token) => {
    const url =
      whereAmI === "Backup" ? "api/backup_auditlog" : "api/restore_auditlog";
    await API.get(url, {
      headers: {
        Authorization: `JWT ${token}`,
      },
    })
      .then(function (response) {})
      .catch(function (error) {
        const data = errorHandler(error);
        setMainMessage({ text: data.message, appearance: "error" });
      });
  };

  const [displayPostInstall, setDisplayPostInstall] = useState(false);
  const Navigate = useNavigate();
  const [welcomePage, setWelcomePage] = useState(false);
  const [currentPath, setCurrentPath] = useState();

  useEffect(() => {
    const Jiratoken = searchParams.get("jwt");
    const AuthenticateReactapp = async (token) => {
      await API.post(
        `api/react-app-auth`,
        { token: Jiratoken },
        {
          headers: {
            Authorization: `JWT ${token}`,
          },
        }
      )
        .then(function (response) {
          setIsAuth("Authenticated");
          logAppUse(token);
          setMainMessage("");
        })
        .catch(function (error) {
          setIsAuth("WrongAuth");
          setMainMessage({ text: error.message, appearance: "error" });
        });
    };

    //Uncomment below code to test the Post Install Page/ Welcome page

    // const updateConnectApp = () => {
    //   //eslint-disable-next-line
    //   AP.request({
    //     url: `/rest/atlassian-connect/1/addons/Revyz-Dev-2/properties/configinfo`,
    //     type: "PUT",
    //     contentType: "application/json",
    //     headers: {
    //       Accept: "application/json",
    //     },
    //     data: '{"config":true}',
    //     success: function (responseText) {},
    //     error: function (xhr, statusText, errorThrown) {
    //       setMainMessage({ text: errorThrown, appearance: "error" });
    //     },
    //   });
    // };

    //Uncomment above code to test the Post Install Page/ Welcome page
    const getConnectAppProp = () => {
      //eslint-disable-next-line
      const addonkey = AP._data.options.addon_key;
      //eslint-disable-next-line
      AP.request({
        url: `/rest/atlassian-connect/1/addons/${addonkey}/properties/configinfo`,
        type: "GET",
        headers: {
          Accept: "application/json",
        },
        success: function (responseText) {
          const responseObj = JSON.parse(responseText);
          setCurrentPath(location.pathname);
          setDisplayPostInstall(responseObj["value"]["config"]);
          if (responseObj["value"]["config"]) {
            Navigate("/postinstall", { replace: true });
            setWelcomePage(true);
          }
        },
        error: function (xhr, statusText, errorThrown) {
          console.error("error");
          setMainMessage({ text: errorThrown, appearance: "error" });
        },
      });
    };

    //eslint-disable-next-line
    AP.context.getToken(function (token) {
      AuthenticateReactapp(token);
      //Uncomment the code to test the Post Install Page/ Welcome page
      //updateConnectApp();
      getConnectAppProp();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isAuth === "Authenticated" ? (
    <div className={styles.mainappcontainer}>
      {/* {!displayPostInstall && <Navbar />} */}
      <Navbar
        displayPostInstall={displayPostInstall}
        welcomePage={welcomePage}
        setWelcomePage={setWelcomePage}
      />

      {mainMessage ? (
        <div>
          <FlagError setFlag={[1]} message={mainMessage} />
        </div>
      ) : (
        ""
      )}
      <div className={styles.appcontainer}>
        <Routes>
          {/* Backup Routes */}
          <Route
            path="/postinstall"
            element={
              <PostInstallPage
                setDisplayPostInstall={setDisplayPostInstall}
                setWelcomePage={setWelcomePage}
                prevPath={currentPath}
              />
            }
          />
          <Route path="/backup" element={<Dashboard appType="Backup" />} />
          <Route path="/backup/jobs" element={<Jobs appType="Backup" />} />
          <Route
            path="/backup/jobs/details"
            element={<JobDetails appType="Backup" />}
          />

          <Route path="/backup/trigger" element={<Backup />} />
          <Route path="/backup/settings" element={<BackupSettings />} />
          <Route path="/backup/audit" element={<AuditLog appType="Backup" />} />
          <Route
            path="/backup/insights"
            element={<Insights appType="Backup" />}
          />

          {/* Restore routes */}

          <Route path="/restore" element={<Dashboard appType="Restore" />} />
          <Route path="/restore/jobs" element={<Jobs appType="Restore" />} />
          <Route
            path="/restore/jobs/details"
            element={<JobDetails appType="Restore" />}
          />
          <Route
            path="/restore/quickrestore"
            element={<IssueLog appType="Restore" />}
          />
          <Route
            path="/restore/advrestore"
            element={<Restore appType="Restore" />}
          />
          <Route
            path="/restore/audit"
            element={<AuditLog appType="Restore" />}
          />
          <Route path="*" element={<Lostroute />} />
        </Routes>
      </div>
    </div>
  ) : isAuth === "isAuthenticating" ? (
    <Authenticating />
  ) : (
    <Unauthenticated />
  );
};

export default App;
